import { render, staticRenderFns } from "./CLoader.vue?vue&type=template&id=b2d8c142&scoped=true"
import script from "./CLoader.vue?vue&type=script&lang=js"
export * from "./CLoader.vue?vue&type=script&lang=js"
import style0 from "./CLoader.vue?vue&type=style&index=0&id=b2d8c142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d8c142",
  null
  
)

export default component.exports